import { Skeleton } from '@/components/ui/skeleton';
import { ReactNode } from 'react';

type PageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  isLoading?: boolean;
  children?: ReactNode;
};

export function PageHeader({
  title,
  description,
  isLoading,
  children,
}: PageHeaderProps) {
  return (
    <div className="tw:flex tw:flex-row tw:justify-between tw:items-center">
      <div className="tw:flex tw:flex-col tw:gap-2">
        <h1 className="tw:text-4xl tw:font-semibold">{title}</h1>
        {description && (
          <Skeleton loading={isLoading}>
            <p className="tw:leading-6">{description}</p>
          </Skeleton>
        )}
      </div>
      {children}
    </div>
  );
}
